import {
  LuArrowLeftRight, LuCalendarPlus, LuLayoutGrid, LuLink, LuRefreshCw, LuUsers,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('calendar', '/calendar', 'calendar', [
    ['create', 'calendar.create', LuCalendarPlus],
    ['nav', 'calendar.nav', LuArrowLeftRight, opt],
    ['view', 'calendar.view', LuLayoutGrid, opt],
    ['team', 'calendar.team', LuUsers, { placement: 'right', ...opt }],
  ]),

  // Reached from "External integrations" in the calendar's side panel.
  tour('calendar_integrations', '/calendar/settings/integrations', 'calendar', [
    ['providers', 'calendar_integrations.providers', LuRefreshCw],
    ['connect', 'calendar_integrations.connect', LuLink, { placement: 'left' }],
  ], { exact: true }),
];

export default tours;
